goog.provide('yext.utils.youtube');

goog.require('goog.string');

/**
 * For the youtube video template, given an item, fill the template with the item info
 * @param {?} template The template where the youtube info lives
 * @param {?} item     The class defining the youtube video
 * @return {string}
 */
yext.utils.youtube.fixupVideoTemplate = function(template, item) {
  var html = template.replace(
    /{{=([^}]+)}}/g,
    function(str, p1) {
      if (p1 === 'ytid') {
        return goog.string.htmlEscape(item.id);
      } else if (p1 === 'title') {
        return goog.string.htmlEscape(item.title);
      } else if (p1 === 'uploader') {
        return goog.string.htmlEscape(item.uploader);
      } else if (p1 === 'duration') {
        return goog.string.htmlEscape(item.duration);
      } else if (p1 === 'thumbnail') {
        return goog.string.htmlEscape(item.thumbnail.replace(/^http:/, 'https:'));
      } else if (p1 === 'url') {
        return goog.string.htmlEscape(item.url);
      } else {
        return str;
      }
    });
  return html;
};
